import FormBox from "./FormBox";

const MultipleFormBoxComp = ({ options, ...props }) => {
  return (
    <div className="row">
      {options.map((data, index) => (
        <div
          key={index}
          className={data?.className ? data.className : "col-12"}
        >
          <h4 className="mt-5 mb-4">{data?.section}</h4>
          <FormBox {...props} options={data.arr} />
        </div>
      ))}
    </div>
  );
};
export default MultipleFormBoxComp;
